/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Pick_TemplateAIAttributes_id_or_name_or_tags_ } from '../models/Pick_TemplateAIAttributes_id_or_name_or_tags_';
import type { Record_string_unknown_ } from '../models/Record_string_unknown_';
import type { ReportPayloadCensusTract } from '../models/ReportPayloadCensusTract';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AiReportsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param requestBody
     * @returns string Ok
     * @throws ApiError
     */
    public runQuery(
        requestBody: {
            query: string;
            data: string;
        },
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/reports/ai/test',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Pick_TemplateAIAttributes_id_or_name_or_tags_ Ok
     * @throws ApiError
     */
    public listReportTemplates(): CancelablePromise<Array<Pick_TemplateAIAttributes_id_or_name_or_tags_>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/reports/ai/templates',
        });
    }
    /**
     * Retrieve a report template in the database, compute the Excel file, feed it to our LLM with the  template and the data, and return the result as html (rich text).
     * @param templateId - The id of the template, stored in the database
     * @param requestBody - The body of the report
     * @param useDevFile
     * @param hiddenTabs
     * @param deletedTabs
     * @returns string The report
     * @throws ApiError
     */
    public generateReport(
        templateId: number,
        requestBody: {
            attachments?: Array<{
                mimeType: string;
                data: string;
            }>;
            reportName?: string;
            payload: (ReportPayloadCensusTract & Record_string_unknown_);
        },
        useDevFile: boolean = false,
        hiddenTabs?: string,
        deletedTabs?: string,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/reports/ai/templates/{templateId}',
            path: {
                'templateId': templateId,
            },
            query: {
                'useDevFile': useDevFile,
                'hiddenTabs': hiddenTabs,
                'deletedTabs': deletedTabs,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Dynamically create a report on-the-fly based on specified sections.
     * @param requestBody - The body of the report and selected sections
     * @param useDevFile
     * @param hiddenTabs
     * @param deletedTabs
     * @returns string The report
     * @throws ApiError
     */
    public generateReportCustom(
        requestBody: {
            attachments?: Array<{
                mimeType: string;
                data: string;
            }>;
            reportName: string;
            sections: Array<(string | {
                mimeType: string;
                data: string;
                type: 'image';
            })>;
            payload: (ReportPayloadCensusTract & Record_string_unknown_);
        },
        useDevFile: boolean = false,
        hiddenTabs?: string,
        deletedTabs?: string,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/reports/ai/custom',
            query: {
                'useDevFile': useDevFile,
                'hiddenTabs': hiddenTabs,
                'deletedTabs': deletedTabs,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
